"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get boundedInt () {
        return boundedInt;
    },
    get isoDateTime () {
        return isoDateTime;
    },
    get nullableLineText () {
        return nullableLineText;
    },
    get optionalLineText () {
        return optionalLineText;
    },
    get requiredLineText () {
        return requiredLineText;
    },
    get versionField () {
        return versionField;
    }
});
const _zod = require("zod");
/**
 * True for U+0000 to U+001F and U+007F. Postgres can't store NUL in `text`,
 * and a line break or tab has no place in a line printed on a prescription.
 */ function hasControlCharacter(value) {
    for(let index = 0; index < value.length; index += 1){
        const code = value.charCodeAt(index);
        if (code <= 0x1f || code === 0x7f) {
            return true;
        }
    }
    return false;
}
function blankToNull(value) {
    if (value === undefined || value === null || value === '') {
        return null;
    }
    return value;
}
const controlCharacterMessage = (label)=>`${label} must not contain line breaks, tabs or other control characters.`;
const requiredLineText = (max, label)=>_zod.z.string({
        error: `${label} is required.`
    }).trim().min(1, {
        error: `${label} is required.`
    }).max(max, {
        error: `${label} must be at most ${String(max)} characters.`
    }).refine((value)=>!hasControlCharacter(value), {
        error: controlCharacterMessage(label)
    });
const lineText = (max, label)=>_zod.z.string({
        error: `${label} must be text.`
    }).trim().max(max, {
        error: `${label} must be at most ${String(max)} characters.`
    }).refine((value)=>!hasControlCharacter(value), {
        error: controlCharacterMessage(label)
    });
const optionalLineText = (max, label)=>lineText(max, label).nullable().optional().transform(blankToNull);
const nullableLineText = (max, label)=>lineText(max, label).nullable().transform(blankToNull);
const boundedInt = (min, max, label)=>_zod.z.number({
        error: `${label} must be a number.`
    }).int({
        error: `${label} must be a whole number.`
    }).min(min, {
        error: `${label} must be between ${String(min)} and ${String(max)}.`
    }).max(max, {
        error: `${label} must be between ${String(min)} and ${String(max)}.`
    });
const versionField = ()=>_zod.z.number({
        error: 'version must be a number.'
    }).int({
        error: 'version must be a whole number.'
    }).min(1, {
        error: 'version must be at least 1.'
    });
const isoDateTime = ()=>_zod.z.string().datetime({
        offset: true
    });
